import { render, staticRenderFns } from "./hidden-editor.vue?vue&type=template&id=71a2bde3&scoped=true"
import script from "./hidden-editor.vue?vue&type=script&lang=js"
export * from "./hidden-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a2bde3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71a2bde3')) {
      api.createRecord('71a2bde3', component.options)
    } else {
      api.reload('71a2bde3', component.options)
    }
    module.hot.accept("./hidden-editor.vue?vue&type=template&id=71a2bde3&scoped=true", function () {
      api.rerender('71a2bde3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/hidden-editor.vue"
export default component.exports